import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Box,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import moment from 'moment';
import { baseUrl } from '../../../utils/constants';
import { BaseOptionChart } from '../../charts';
import { useConstantsContext } from '../../../context/constants_context';

// const CHART_DATA = [
//   {
//     name: 'Gweru',
//     type: 'column',
//     data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
//   },
//   {
//     name: 'Head Office',
//     type: 'area',
//     data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
//   },
//   {
//     name: 'Harare',
//     type: 'line',
//     data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
//   }
// ];

export default function AppWebsiteVisits({ dataList }) {
  const { payCycles, chartData, getMonthlyReport, getDistStats } = useConstantsContext();
  const group = Number(sessionStorage.getItem('province'));
  const payCycleId = Number(sessionStorage.getItem('payCycleId'));
  const chartLabels = chartData.map((i) => i.descriptions);
  const chartSeries = chartData.map((i) => i.count);
  const CHART_DATA = [
    {
      name: '#',
      type: 'column',
      data: chartSeries
    }
  ];

  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '55%', borderRadius: 4 } },
    fill: { type: ['solid'] },
    colors: ['#0C5935'],
    dataLabels: {
      enabled: true,
      formatter(val) {
        return `${val}`;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        color: '#00000'
      }
    },
    labels: chartLabels,
    xaxis: { type: 'text' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} clients`;
          }
          return y;
        }
      }
    }
  });

  const changeCycle = (dates, cycle) => {
    if (group === 0) {
      getMonthlyReport(dates);
    } else if (group > 0) {
      console.log('group is ', group);
      console.log('cycle is ', cycle);
      getDistStats(cycle, group);
    } else {
      getMonthlyReport('2010-01-01');
    }
  };

  return (
    <Card>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10" mr="10">
        {group > 0 && <CardHeader title="By District..." subheader="" />}
        {group === 0 && <CardHeader title="By Province..." subheader="" />}
        <FormControl sx={{ mr: 2 }}>
          <InputLabel id="payCycleLbl">Stroke</InputLabel>
          <Select
            id="cycleId"
            name="cycleId"
            size="small"
            variant="outlined"
            style={{ width: 220 }}
            onChange={(e, key) => {
              changeCycle(e.target.value, key.key.slice(4));
            }}
          >
            <MenuItem key="" value="">
              Not Selected
            </MenuItem>
            {payCycles.slice(0, 12).map((item) => (
              <MenuItem key={item.payCycleId} value={item.payDate}>
                {moment(item.payDate).isValid() ? moment(item.payDate).format('YYYY-MM-DD') : ''}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
